export const TARGETS={
    declarer:"declare",
    followup: "followup"
}